import { render, staticRenderFns } from "./theoryLibaray.vue?vue&type=template&id=18aa20f0&scoped=true"
import script from "./theoryLibaray.vue?vue&type=script&lang=js"
export * from "./theoryLibaray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa20f0",
  null
  
)

export default component.exports